export default __webpack_public_path__ + "locales/lo-LA/PreparationPortal.json?hash=1601c40ee5aa1fc9cec77a2231ab9dd7";